import styles from "./InteractionStats.module.scss";
import condolence from "@images/icons/condolence.svg";
import flower from "@images/icons/flower.svg";
import candle from "@images/icons/candle.svg";


type Props = {
  stats?: {
    condolences?: number
    flowers?: number
    candles?: number
  },
  className?: string
}

export default ({stats, className}: Props) => {
  return <>
    {stats && <div className={`${styles.stats} ${className ?? ''}`} >
        <span title={`Er zijn ${stats.condolences ?? 'nog geen'} condoleances geplaatst`}><img src={condolence} alt={'Condoleances'}/><span>{stats.condolences ?? 0}</span></span>
        <span title={`Er zijn ${stats.flowers ?? 'nog geen'} bloemen geplaatst`}><img src={flower} alt={'Bloemen'}/><span>{stats.flowers ?? 0}</span></span>
        <span title={`Er zijn ${stats.candles ?? 'nog geen'} kaarsjes gebrand`}><img src={candle} alt={'Kaarsjes'}/><span>{stats.candles ?? 0}</span></span>
    </div>}
  </>
}